import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchPinFilterEntity } from '../../domain/entities/BranchPinFilterEntity'

export class BranchPinFilterModel extends BranchPinFilterEntity {
  branchId?: number
  constructor(dataDto: BranchPinFilterEntity) {
    super()
    mapEntityProperties<BranchPinFilterModel>(this, dataDto, {
      exclude: ['branch'],
      map: {
        branchId: dataDto.branch?.id
      }
    })
  }
}
